import React from 'react';

import './navbar-trigger.css';

export default ({ collapsed, className ,onClick }) => (
    <div className={`menu-icon ${className} ${ collapsed ? '': 'open' }`} onClick={ onClick }>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
);



// WEBPACK FOOTER //
// ./src/App/components/navbar-trigger/navbar-trigger.js